import { useRender } from '@base-ui/react/use-render';
import type { ReactElement } from 'react';
import { cn } from '../util/classes.ts';

export type JoinProps = useRender.ComponentProps<'div'> & {
    orientation?: 'horizontal' | 'vertical';
};

export function Join({ className, orientation = 'horizontal', render, ...props }: JoinProps): ReactElement {
    return useRender({
        defaultTagName: 'div',
        render,
        props: {
            ...props,
            className: cn('flex', orientation === 'vertical' ? 'flex-col' : 'flex-row', className),
            // children read this to pick the axis they merge on
            'data-join-children': orientation,
        },
    });
}
